/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ClassificationTier,
    ClassificationTierFromJSON,
    ClassificationTierToJSON,
} from '../models/ClassificationTier';

export interface DeleteTiersRequest {
    id: string;
}

export interface GetAllTiersRequest {
    id: string;
}

export interface UpdateTiersRequest {
    id: string;
    classificationTier: Array<ClassificationTier>;
}

/**
 * 
 */
export class ClassificationTierApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteTiers without sending the request
     */
    async deleteTiersRequestOpts(requestParameters: DeleteTiersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTiers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/classification-tier`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteTiersRaw(requestParameters: DeleteTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteTiersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTiers(requestParameters: DeleteTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTiersRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllTiers without sending the request
     */
    async getAllTiersRequestOpts(requestParameters: GetAllTiersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllTiers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/classification-tier`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllTiersRaw(requestParameters: GetAllTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClassificationTier>>> {
        const requestOptions = await this.getAllTiersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClassificationTierFromJSON));
    }

    /**
     */
    async getAllTiers(requestParameters: GetAllTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClassificationTier>> {
        const response = await this.getAllTiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateTiers without sending the request
     */
    async updateTiersRequestOpts(requestParameters: UpdateTiersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTiers().'
            );
        }

        if (requestParameters['classificationTier'] == null) {
            throw new runtime.RequiredError(
                'classificationTier',
                'Required parameter "classificationTier" was null or undefined when calling updateTiers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/classification-tier`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['classificationTier']!.map(ClassificationTierToJSON),
        };
    }

    /**
     */
    async updateTiersRaw(requestParameters: UpdateTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClassificationTier>>> {
        const requestOptions = await this.updateTiersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClassificationTierFromJSON));
    }

    /**
     */
    async updateTiers(requestParameters: UpdateTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClassificationTier>> {
        const response = await this.updateTiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
